<template>
  <div>
    <v-card class="ma-2" v-if="!display">
      <v-card-text>
        <div class="text-center headline">Anda harus input data PERUSAHAAN terlebih dulu !</div>
      </v-card-text>
    </v-card>
    <v-card class="ma-2" v-if="display">
      <v-card-title  class="teal white--text">
        Pajak
        <v-spacer />
        <v-btn  @click.stop="openForm(null)">
          <v-icon left>add</v-icon>
          Tambah
        </v-btn>
      </v-card-title>


      <v-data-table
          class="elevation-1"
          :headers="headers"
          :items="pos3List"
          :items-per-page="10"
          :single-select="true"
          item-key="id"
      >
          <template v-slot:item.jenis="{item}">
            <v-btn icon color="grey" @click.prevent="getLinkDownload(item.dokumen)"><v-icon>get_app</v-icon></v-btn>
            {{ item.jenis }}
          </template>
          <template v-slot:item.tanggalTerima="{item}">
            {{ getDatefnsFormat(item.tanggalTerima) }}
          </template>
          <template v-slot:item.actions="{item}">
            <v-btn icon color="cyan" @click="openForm(item)"> <v-icon>mdi-pencil</v-icon> </v-btn>
            <v-btn icon color="pink" @click="deletePajak(item.id)"> <v-icon>delete</v-icon> </v-btn>
          </template>
      </v-data-table>

    </v-card>

    <v-dialog v-model="dlgPajak" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Tambah Pajak</span>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form3"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    label="Jenis Pajak"
                    type="text"
                    outlined
                    v-model="jenis"
                    :rules="[rules.required]"
                  />  
                  <v-text-field
                    label="Masa Tahun Pajak"
                    type="text"
                    outlined
                    v-model="masa"
                    :rules="[rules.required]"
                  />  
                  <v-text-field
                    label="No. Bukti Penerimaan"
                    type="text"
                    outlined
                    v-model="nomorTerima"
                    :rules="[rules.required]"
                  />             
                </v-col>
                <v-col cols="6">     
                  <v-menu
                    v-model="menuTerima"
                    :close-on-content-click="false"
                    max-width="290"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="computedDateFormattedDatefns"
                        clearable
                        label="Tanggal Bukti Terima"
                        readonly
                        v-on="on"
                        outlined
                        :rules="[rules.required]"
                        @click:clear="tanggalTerima = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="tanggalTerima"
                      @change="menuTerima = false"
                    ></v-date-picker>
                  </v-menu>                    
                  <v-file-input 
                    outlined 
                    accept=".jpg,.png,.pdf"
                    label="Dokumen Pajak"
                    v-model="fileDokumen"
                    chips
                    :rules="[validateFileDokumen()]"         
                    :placeholder="dokumen"
                    append-icon="get_app"
                    @click:append="getLinkDownload(dokumen)"          
                  ></v-file-input>
                </v-col>
              </v-row>              
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" dark @click="dlgPajakSimpanClick">Simpan</v-btn>
          <v-btn color="orange" dark @click="closeForm()">Batal</v-btn>
          <v-btn color="info" dark @click="resetForm3">Reset</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="loginExpired" max-width="400" persistent>
        <v-card>
            <v-card-title>Login Expired</v-card-title>
                <v-card-text>Silakan Login Ulang</v-card-text>
            <v-card-actions>
                <v-btn color="red" @click="logoutClick()">Ya</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { format, parseISO } from 'date-fns'
import { rules as Rules } from "./../../lib/rules";
const apiUrl = process.env.VUE_APP_ROOT_API

export default {
  data: function() {
    return {
      valid: true,
      dlgPajak: false,
      jenis: '',
      masa: '',
      nomorTerima: '',
      tanggalTerima: "",
      menuTerima: false,
      dokumen: "",
      pos3Count: 0,
      pos3List: [],
      isEditing: false,
      editId: null,
      dlgEverOpened: false,
      fileDokumen: null,
      rules: {
          required: Rules.required,
      },

      // Table headers
      headers: [
        { text: "Jenis", value: "jenis", class: "green accent-2 subtitle-2" },
        { text: "Masa Tahun", value: "masa", class: "green accent-2 subtitle-2" },
        { text: "No. Bukti", value: "nomorTerima", class: "green accent-2 subtitle-2"  },
        { text: "Tanggal Bukti", value: "tanggalTerima", class: "green accent-2 subtitle-2"  },
        { text: "", value: "actions", sortable: false,  class: "green accent-2 subtitle-2" },
      ],

      submitting: false,
      loginExpired:false

    }
  },
  computed: {
    display: function() {
      return this.$store.getters['ven/venId'] != -999
    },
    venId: function() { 
      return this.$store.getters['ven/venId']
    },
    computedDateFormattedDatefns () {
      return this.tanggalTerima ? format(parseISO(this.tanggalTerima), "dd MMM yyyy") : ''
    },
  },
  methods: {
    validateFileDokumen: function() {
      if (this.isEditing && this.dokumen != "") return true;
      return this.fileDokumen != null || "Harap melampirkan scan dokumen pajak";
    },
    resetForm: function() {
      this.tanggalTerima = "";
      this.dokumen = "";
      this.editId = null;
      this.fileDokumen = null;

      if (this.dlgEverOpened) this.$refs.form3.reset();
    },
    closeForm: function() {
      this.resetForm();
      this.dlgPajak = false;
      this.isEditing = false;
    },
    openForm: function(pajak) {
      this.resetForm();

      if (pajak) {
        this.jenis = pajak.jenis;
        this.masa = pajak.masa;
        this.nomorTerima = pajak.nomorTerima;
        this.tanggalTerima = pajak.tanggalTerima;
        this.dokumen = pajak.dokumen;
        this.isEditing = true;
        this.editId = pajak.id;
      }

      this.dlgPajak = true;
      this.dlgEverOpened = true;
    },
    dlgPajakSimpanClick: async function() {
      if (!this.$refs.form3.validate()) {
        return null
      }
      const newPajak = {
        id: null,
        jenis: this.jenis,
        masa: this.masa,
        nomorTerima: this.nomorTerima,
        tanggalTerima: this.tanggalTerima,
        dokumen: ''
      }
      const fdata = new FormData()
      fdata.append('jenis', this.jenis)
      fdata.append('masa', this.masa)
      fdata.append('nomorTerima', this.nomorTerima)
      fdata.append('tanggalTerima', this.tanggalTerima)
      fdata.append('vendorId', this.venId)
      if (this.fileDokumen) fdata.append('dokumen', this.fileDokumen)

      this.$store.dispatch('displayProgBar')  

      
      if (this.isEditing) {
        this.submitting = true;

        await axios.put(apiUrl + "/vendor/pajak/" + this.editId, fdata, { headers: { 'Content-Type': 'multipart/form-data' }})
        .then( (response) => {
          this.$store.dispatch('displayAlert', {
            color: 'success', 
            message: `Data pajak telah diperbarui` 
          });

          //this.$store.dispatch('ven/assignVendor', response.data.data);
          //this.$store.commit('reg/setStatusPajak', 'V');
          window.scroll(0,0);

          const index = this.pos3List.findIndex(element => element.id === this.editId);
          if (index != -1) {
            this.pos3List.splice(index, 1);
            this.pos3List.push(response.data);
          }

        })
        .catch ((error) => {
          if(error.response.status == 401) {
            this.loginExpired = true;
          }else if(error.response.status == 422) {
            this.loginExpired = true;
          }else {
            this.$store.dispatch('displayAlert', {color: 'error', message: `Gagal menyimpan! ${error.response.data.message}`})
            window.scroll(0,0)
          }
        })
        .finally(() => {
          this.$store.dispatch('closeProgBar');
          this.submitting = false;
        });

      } else {
        // simpan ke database
        this.submitting = true;

        await axios.post(apiUrl + '/vendor/registrasi/pajak', fdata, { headers: { 'Content-Type': 'multipart/form-data' }})
        .then((response) => {
          this.$store.dispatch('displayAlert', {
            color: 'success', 
            message: `Data Pajak telah tersimpan !` 
          });

          this.$store.dispatch('ven/assignVendor', response.data.data)
          this.$store.commit('reg/setStatusPajak', 'V')
          window.scroll(0,0)

          // update datatable
          newPajak.id = response.data.data.pajakId
          newPajak.dokumen = response.data.data.dokumen
          this.pos3List.push(newPajak)
          this.pos3Count = this.pos3List.length
        })
        .catch((error) => {
          if(error.response.status == 401) {
            this.loginExpired = true;
          }else if(error.response.status == 422) {
            this.loginExpired = true;
          }else {
            this.$store.dispatch('displayAlert', {color: 'error', message: `Gagal menyimpan! ${error.response.data.message}`})
            window.scroll(0,0)
          }
        })
        .finally(() => {
          this.$store.dispatch('closeProgBar');
          this.submitting = false;
        });
      }

      this.closeForm();

    },
    resetForm3: function() {
      this.$refs.form3.reset() 
    },
    deletePajak: async function(id) {
      // hapus database
      this.submitting = true;

      await axios.delete(apiUrl+`/vendor/pajak/${id}`)
      .then((response) => {
        if (response.data.statusCode != 200) { // hapus gagal
          this.$store.dispatch('displayAlert', {color: 'error', message: 'Error dalam penghapusan data ! Silahkan coba beberapa saat lagi' })
          window.scroll(0,0)
        }
        else { // hapus berhasil
          // hapus element data table
          this.pos3List = this.pos3List.filter(function(el) {
            return el.id !== id;
          });
          this.pos3Count = this.pos3List.length;
        }
      })
      .catch((error) => {
        console.log(error)
        this.$store.dispatch('displayAlert', {color: 'error', message: 'Error dalam penghapusan data ! Silahkan coba beberapa saat lagi' })
      })     
      .finally( () => {
        this.submitting = false;
      })
    },
    getDatefnsFormat: function(date) {
      return format(parseISO(date), "dd MMM yyyy")
    },
    getLinkDownload: function(dok) {
      axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = dok
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    },
    getDateFormattedDatefns: function(date) {
      return date ? format(parseISO(date), "dd MMM yyyy") : ''
    },
    logoutClick: function() {
        this.$store.dispatch('logout')
        .then(() => {
            this.$router.push('/')
        })
    }
  },
  created: async function() {
    this.$store.dispatch('displayPageTitle', 'Pajak Perusahaan')
    await axios.get(apiUrl+'/vendor/pajak/'+this.venId)
    .then((response) => {
      if (response.data.statusCode != 200) {
        this.pos3List = []
      }
      else {
        response.data.data.forEach(element => {
          this.pos3List.push(element)
        })              
      }
      this.pos3Count = this.pos3List.length
    })
    .catch((error) => {
      console.log(error)
    })  
  }
}
</script>

<style>

</style>